import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'info-dialog',
    templateUrl: './infoDialog.component.html',
    styleUrls: ['./infoDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class InfoDialogComponent {
    action: string;
    dialogRef: any;
    message = '';

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.message = _data.message;
        this.translationLoader.loadTranslations(polish, english);
    }
}
